import { FC } from 'react';
import { useEffectOnce } from 'usehooks-ts';
import { Trans, useTranslation } from 'react-i18next';
import { ModalComponentBaseProps } from '@pcmp/react-providers';
import { Sheets, ModalHeader, ModalBody } from '@ingka/modal';

import { useTrackContent } from '@/lib/hooks/tracking';
import { useModalGoToProfile } from '@/lib/hooks/modal';

type AboutSiderProps = ModalComponentBaseProps;

const useAboutTracking = () => {
  const [trackContent] = useTrackContent();

  useEffectOnce(() => {
    trackContent({ content: 'about', type: 'sider' });
  });
};

export const AboutSider: FC<AboutSiderProps> = ({ handleDismiss, ...rest }) => {
  const { t } = useTranslation();
  const goBack = useModalGoToProfile();

  useAboutTracking();

  return (
    <Sheets
      {...rest}
      alignment="right"
      aria-label={t('page.about.shortTitle')}
      footer={null}
      header={
        <ModalHeader ariaCloseTxt={t('label.close')} backBtnClick={goBack} />
      }
      size="small"
    >
      <ModalBody data-testid="aboutSider">
        <div>
          <h1 className="font-bold text-2xl leading-loose">
            {t('page.about.titles.title1')}
          </h1>
          <p className="mt-[10px] leading-relaxed ">
            <Trans i18nKey="page.about.descriptions.description1" />
          </p>
        </div>

        <div className="mt-5">
          <h1 className="font-bold text-2xl leading-loose">
            {t('page.about.titles.title2')}
          </h1>
          <p className="mt-[10px] leading-relaxed ">
            <Trans i18nKey="page.about.descriptions.description2" />
          </p>
        </div>

        <div className="mt-5">
          <h1 className="font-bold text-2xl leading-loose">
            {t('page.about.titles.title3')}
          </h1>
          <p className="mt-[10px] leading-relaxed ">
            <Trans i18nKey="page.about.descriptions.description3" />
          </p>
        </div>

        <div className="mt-5">
          <h1 className="font-bold text-2xl leading-loose">
            {t('page.about.titles.title4')}
          </h1>
          <div className="mt-[10px]">
            <Trans
              i18nKey="page.about.descriptions.description4"
              components={{ ul: <ul className="list-disc pl-4" />, li: <li /> }}
            />
          </div>
        </div>
      </ModalBody>
    </Sheets>
  );
};
